import { connect } from 'react-redux';
import Tree from '../components/Tree/Tree';
import { setPage, nextPage, prevPage } from '../actions/research';

const mapStateToProps = (state) => {
  const { exercises, selectedPage, sequence, sequenceIndex } = state.research;
  return {
    exercises: exercises.filter((item) => item.category !== 'build'),
    selected: selectedPage,
    title: 'Research',
    enableNext: sequenceIndex < sequence.length - 1,
    enablePrev: sequenceIndex > 0,
  };
};

const mapDispatchToProps = {
  setPage,
  nextPage,
  prevPage,
};

const ResearchTree = connect(mapStateToProps, mapDispatchToProps)(Tree);

export default ResearchTree;
